import {API_URL} from '../../../../resources/api';

export const winLosesURL : string = `${API_URL}dashboard/music/winloses`;
export const rankURL : string = `${API_URL}dashboard/music/rank`;